"use client"
import clsx from "clsx"
import { HeaderVariant } from "./constants"
import Link from "next/link"

interface HeaderIconProps {
  variant?: HeaderVariant
  isScrolled?: boolean
  Icon: React.ComponentType<{ color?: string; className?: string }>
  href?: string 
}

export const HeaderIcon = ({ variant="transparent", isScrolled, Icon, href }: HeaderIconProps) => {
  const color = variant === "transparent" ? "white" : "#1B1D2B"

  return href ? (
    <Link href={href} target="_blank" aria-label="header-icon-link">
      <Icon
        color={color}
        className={clsx(
          isScrolled && "scale-85 origin-right",
          "transition-all duration-300 cursor-pointer flex items-center h-fit"
        )}
      />
    </Link>
  ): (
    <Icon
      color={color}
      className={clsx(
        isScrolled && "scale-85 origin-right",
        "transition-all duration-300 cursor-pointer flex items-center h-fit"
      )}
    />
  )


}
